import { useEffect, useState } from 'react';
import { Button, Pagination } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@hooks/redux';
import { getLoanRequestsApi } from '@http/loans';
import digitNumber from '@utils/digitNumber';
import getStatus from '@utils/getStatus';
import { formatDate } from '@utils/formatDate';

function LoanApplications() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const loanRequests = useAppSelector(state => state.loansReducer.loanRequests);

  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    dispatch(getLoanRequestsApi(1));
  }, []);

  const changePage = (page: number) => {
    setCurrentPage(page);
    dispatch(getLoanRequestsApi(page));
  };

  return (
    <div className='flex justify-center'>
      <div className='lg:w-[1130px] w-full max-lg:px-4'>
        <div className='flex'>
          <div className='py-4 lg:py-8 w-full h-full bg-white mb-12'>
            <div className='flex justify-between items-center'>
              <h1 className='text-xl font-medium color-active'>{t('Loan requests')}</h1>
              <div className='flex gap-3'>
                <Button onClick={() => navigate('/loans')}>{t('Back')}</Button>
                <Button type='primary' onClick={() => navigate('/loans/applications/create')}>
                  {t('Submit request')}
                </Button>
              </div>
            </div>

            <div className='mt-7'>
              <div
                className='tableHeader gap-5 grid grid-cols-12 py-5 md:px-5'
                style={{ borderBottom: '1px solid #eee' }}
              >
                <p className='col-span-2 max-md:hidden'>{t('Date')}</p>
                <p className='col-span-2 max-md:col-span-4'>{t('Amount')}</p>
                <p className='col-span-2 max-md:hidden'>{t('Loan term')}</p>
                <p className='col-span-3 max-md:hidden'>{t('Purpose')}</p>
                <p className='col-span-2 max-md:col-span-8 text-right'>{t('Status')}</p>
              </div>

              {loanRequests?.results?.length > 0 ? (
                <div>
                  {loanRequests?.results?.map((item: any) => (
                    <div
                      key={item.id}
                      style={{ borderBottom: '1px solid #eee' }}
                      className='md:px-5 py-5 gap-5 grid grid-cols-12 listItem items-center md:text-base max-md:text-sm'
                    >
                      <p className='col-span-2 max-md:hidden font-medium'>{formatDate(item?.created_at)}</p>
                      <p className='col-span-2 max-md:col-span-4 font-medium'>
                        {digitNumber(item?.amount)} <span className='font-semibold'>{item?.ccy}</span>
                      </p>
                      <p className='col-span-2 max-md:hidden'>{item?.term}</p>
                      <p className='col-span-3 max-md:hidden'>{item?.purpose}</p>
                      <p className='col-span-2 max-md:col-span-8 text-right'>{getStatus(item?.status, 12, t)}</p>
                    </div>
                  ))}

                  <div className='flex justify-end mt-7'>
                    <Pagination
                      onChange={changePage}
                      current={loanRequests?.current_page || currentPage}
                      defaultPageSize={10}
                      total={loanRequests?.total_pages * 10}
                      showSizeChanger={false}
                    />
                  </div>
                </div>
              ) : (
                <div className='h-24 lg:h-72 flex items-center justify-center'>
                  <p>{t('No requests')}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoanApplications;
